import { apm } from "@elastic/apm-rum";
import { Close } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";

interface props {
  maximizeTable?: boolean;
  maximizeHeight?: boolean;
  visible: boolean;
  handleClose: () => void;
  children: JSX.Element | JSX.Element[];
  title: string;
}

export default function PopoverElement({
  maximizeTable,
  maximizeHeight,
  visible,
  handleClose,
  children,
  title,
}: props) {
  const showAxisscale = defaultStore((state) => state.showAxisscale);
  const authMode = defaultStore((state) => state.authMode);
  const darkTheme = defaultStore((state) => state.darkTheme);

  const width = "444px";
  const widthExpanded = "800px";
  const height =
    authMode === "edit" ? (showAxisscale ? "476px" : "428px") : "428px";
  const heightExpanded = "100%";

  return (
    <Box
      sx={{
        width: maximizeTable
          ? { xs: width, md: widthExpanded, lg: "1100px" }
          : width,
        height: visible
          ? maximizeTable || maximizeHeight
            ? heightExpanded
            : height
          : "0px",
        top: "-8px",
        left: visible ? "0" : "-500px",
        position: "absolute",
        zIndex: 1,
        padding: "8px",
        backgroundColor: "whiteBackground.main",
        backdropFilter: "blur(10px)",
        borderRadius: "0px 10px 10px 0px",
        transition: "left 0.3s, height 0.3s, width 0.3s",
        pointerEvents: "auto",
      }}
    >
      <Box
        sx={{
          padding: 1.5,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          transition: "width 0.3s",
          backgroundColor: darkTheme ? "darkblue.main" : "white",
          borderRadius: "10px",
          height: "calc(100% - 24px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            position: "sticky",
            top: "0",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              color: darkTheme ? "white" : "darkblue.main",
            }}
          >
            {title}
          </Typography>
          <IconButton
            onClick={() => monitor(apm, "close-popover | Toolbar", handleClose)}
            disableRipple={true}
          >
            <Close
              sx={{
                marginRight: "-8px",
                color: darkTheme ? "white" : "darkblue.main",
                "@media (hover: hover)": {
                  ":hover": { color: "secondary.main" },
                },
              }}
            />
          </IconButton>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            overflow: "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
